export default __webpack_public_path__ + "static/media/delete-icon.60aaa2e4.svg";